module.exports = __webpack_public_path__ + "static/media/15UN-Habitat10.c56acbe8.jpg";